import React from "react";
import { Phone, MapPin, Clock, Mail, Star } from "lucide-react";
import { businessInfo, services, payments } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-black text-zinc-400 border-t border-red-900/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 pb-10">
        <div className="grid lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <img src={businessInfo.logoUrl} alt="1/2 Fast Mobile Keys" className="h-14 w-auto" />
            <p className="mt-5 text-sm text-zinc-500 leading-relaxed">
              Mobile locksmith and automotive key specialist serving Louisa, KY and the Tri-State 24 hours a day.
            </p>
            <div className="mt-5 flex items-center gap-1 text-sm">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              ))}
              <span className="ml-1 text-zinc-500">5.0 on Yelp</span>
            </div>
          </div>

          <div>
            <h4 className="text-yellow-400 font-bold text-sm uppercase tracking-widest">Services</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <a href="#services" className="hover:text-red-500 transition-colors">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-yellow-400 font-bold text-sm uppercase tracking-widest">Quick Links</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#pricing" className="hover:text-red-500">Price Sheet</a></li>
              <li><a href="#about" className="hover:text-red-500">About Shane</a></li>
              <li><a href="#reviews" className="hover:text-red-500">Reviews</a></li>
              <li><a href="#area" className="hover:text-red-500">Service Area</a></li>
              <li><a href="#contact" className="hover:text-red-500">Contact</a></li>
              <li><a href={businessInfo.yelpUrl} target="_blank" rel="noreferrer" className="hover:text-red-500">Yelp Page</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-yellow-400 font-bold text-sm uppercase tracking-widest">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                <a href={`tel:${businessInfo.phoneRaw}`} className="hover:text-red-500">{businessInfo.phone}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                <a href={`mailto:${businessInfo.email}`} className="hover:text-red-500 break-all">{businessInfo.email}</a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                <span>{businessInfo.serviceRegion}</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Clock className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                <span>{businessInfo.hours}</span>
              </li>
            </ul>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {payments.map((p) => (
                <span key={p} className="px-2 py-0.5 rounded bg-zinc-900 border border-zinc-800 text-zinc-400 text-xs">{p}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-3 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} 1/2 Fast Mobile Keys. All rights reserved.</p>
          <p>Owned &amp; operated by {businessInfo.owner} · {businessInfo.city}, {businessInfo.state}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
